import { formatAgentQuestionAnswerCopy } from './formatAgentQuestionAnswerCopy.js'

export function buildAgentQuestionAnsweredBlocks(question, answer) {
  return [
    {
      type: 'markdown',
      content: `**${question.prompt}**`,
    },
    {
      type: 'markdown',
      variant: 'muted',
      content: formatAgentQuestionAnswerCopy(answer),
    },
  ]
}
